const Checkbox = ({value, onChange, ...props}) => {
    const handleChange = (event) => {
        event.stopPropagation();
        onChange(event.currentTarget.checked);
    };
    return (
        <input type="checkbox" checked={Boolean(value)} onChange={handleChange} {...props} />
    );
};

export default Checkbox;
